<template>
  <div class="l-content">
    <div class="barometer row">
      <div class="barometer-copy col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2 col-md-5 col-md-offset-2">
        <slot name="copy"/>
      </div>
      <div class="barometer-indicators col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2 col-md-8 col-md-offset-1">
        <div class="row mr-hack">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Barometer'
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
.barometer {
  &-copy {
    margin-bottom: 50px;
    @media (min-width: $screen-md-min) {
      margin-bottom: 0;
    }
    h2 {
      margin-bottom: 28px;
    }
  }
  .mr-hack {
    margin-right: -8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Barometer.vue